var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceAlertGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28.71,
    viewBox: "0 0 30 28.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#696969;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.682 -3.95)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.759,32.66H29.586c2.505,0,3.988-3.733,2.505-6.34L20.178,5.561a2.714,2.714,0,0,0-4.96,0L3.3,26.32C1.771,28.927,3.254,32.66,5.759,32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.279,15.2H28.364c-.511,0-.92,1.278-.716,2.454L29.08,28.392c.256,1.738,1.227,1.738,1.483,0l1.432-10.737C32.2,16.478,31.841,15.2,31.279,15.2Z",
    transform: "translate(-12.175 -5.498)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.534,
    cy: 1.687,
    rx: 1.534,
    ry: 1.687,
    transform: "translate(16.139 26.626)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAlertGray);
export default __webpack_public_path__ + "static/media/service_alert_gray.969ab8bb660c2b795bc893e0879f71fa.svg";
export { ForwardRef as ReactComponent };